import { Text } from '@thanx/uikit/text'
import { useGetUserListCampaignsQuery } from 'api/userLists'
import HeaderCell from 'components/HeaderCell'
import Spinner from 'components/Spinner'
import { buildTranslate } from 'locales'
import React from 'react'
import { Table } from 'react-bootstrap-five'
import { Link } from 'react-router-dom'

const t = buildTranslate('user_lists.campaigns')

// Palette names: 'jungle' and 'emerald' (see src/stylesheets/variables/_palette.scss)
const CAMPAIGN_TYPE_COLORS: Record<string, string> = {
  custom: '#1abc9c',
  default: '#2ecc71',
}

type Props = {
  listId: number
}

const CampaignsTab: React.FC<Props> = ({ listId }) => {
  const { data, isLoading } = useGetUserListCampaignsQuery({
    userListId: listId,
    state: 'active',
  })

  const campaigns = data?.data || []

  return (
    <div className="container py-l">
      <Spinner isLoading={isLoading} className="text-center py-xl">
        {campaigns.length === 0 ? (
          <div className="text-center py-xl">
            <Text.BodyText3 color="grey50" tag="p" className="m-0 font-italic">
              {t('empty')}
            </Text.BodyText3>
          </div>
        ) : (
          <Table responsive className="mb-0">
            <thead>
              <tr>
                <HeaderCell>{t('columns.name')}</HeaderCell>
                <HeaderCell>{t('columns.date_created')}</HeaderCell>
                <HeaderCell>{t('columns.created_by')}</HeaderCell>
                <HeaderCell />
              </tr>
            </thead>
            <tbody>
              {campaigns.map(campaign => (
                <tr key={campaign.id}>
                  <td className="body-text-4 py-s px-m">
                    <div>{campaign.name}</div>
                    <div className="d-flex align-items-center mt-xxs">
                      <span
                        className="d-inline-block mr-xxs border-round"
                        style={{
                          width: 8,
                          height: 8,
                          backgroundColor:
                            CAMPAIGN_TYPE_COLORS[campaign.type] ||
                            CAMPAIGN_TYPE_COLORS.default,
                        }}
                      />
                      <span className="text-uppercase grey-70 font-size-12">
                        {campaign.type.replace(/_/g, ' ')}
                      </span>
                    </div>
                  </td>
                  <td className="body-text-4 py-s px-m">
                    {new Date(campaign.createdAt).toLocaleDateString()}
                  </td>
                  <td className="body-text-4 py-s px-m">
                    {campaign.createdBy}
                  </td>
                  <td className="body-text-4 py-s px-m">
                    <Link
                      to={`/thanx_campaigns/${campaign.id}`}
                      className="belize-hole no-underline"
                    >
                      {t('view')}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Spinner>
    </div>
  )
}

export default CampaignsTab
